import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CmsImageUrls, Restaurant } from '@/models';
import { getCountryCodeByTopLevelDomain } from '@/helpers';

@Component({
    name: 'CmgRetroCreditRestaurantSelection',
})
export default class CmgRetroCreditRestaurantSelection extends Vue {
    error = '';
    selectedRestaurant: Restaurant | null = null;

    get restaurants(): Restaurant[] {
        return this.$appStore.state.retroCredit.restaurants;
    }

    get countryCode(): string {
        return getCountryCodeByTopLevelDomain();
    }

    get infoImage(): CmsImageUrls {
        return this.$appStore.state.cms.images.retroCredit[this.countryCode.toLowerCase()].receiptZip;
    }

    mounted() {
        this.selectedRestaurant = this.$appStore.state.retroCredit.selectedRestaurant;
    }

    onSelectRestaurant(restaurant: Restaurant) {
        this.error = '';

        this.selectedRestaurant = restaurant;
    }

    onClickNext() {
        this.error = '';

        if (!this.selectedRestaurant) {
            this.error = 'Please Select Your Restaurant';
            return;
        }
        this.$services.ui.nextFocus('step-num');
        this.$emit('select', this.selectedRestaurant);
    }
}
